import { Link } from 'react-router';
import { Empty } from '../components/ui';

export function NotFound() {
  return (
    <div className="card">
      <Empty title="Page not found" sub="This console route does not exist." />
      <p style={{ textAlign: 'center', paddingBottom: 24 }}>
        <Link className="link" to="/">
          Back to the catalog
        </Link>
      </p>
    </div>
  );
}
